import React, { memo } from "react";
import "./PlatformTableViewer.scss";

function PlatformTableViewer(props) {
  const { data } = props;
  const fieldColumns = Object.keys(data);
  const dataTypeColumns = Object.values(data);
  return (
    <table className="platform-table-view">
      <tr>
        <th>Column</th>
        <th>Data Type</th>
      </tr>
      {fieldColumns.map((d, i) => {
        return (
          <tr key={i}>
            <td>{d}</td>
            <td>{dataTypeColumns[i]}</td>
          </tr>
        );
      })}
    </table>
  );
}

export default memo(PlatformTableViewer);
